import { Tabs } from "@chakra-ui/react"
import EventsEditorComponent from "./events-editor-component"
import TabsComponent from "./tabs-component"

const StaffComponent = () => {

    const tabLabels = ["Members", "Events Editor", "Events List"]
    return (
        <>
            <TabsComponent variant="enclosed" labels={tabLabels}>
                <Tabs.Content value="Members">
                    Manage users
                </Tabs.Content>
                <Tabs.Content value="Events Editor">
                    <EventsEditorComponent />
                </Tabs.Content>
                <Tabs.Content value="Events List">
                List of events
                </Tabs.Content>
                
            </TabsComponent>
        </>
    )
}

export default StaffComponent